import { render, staticRenderFns } from "./drawer-pgd-form-causas.vue?vue&type=template&id=6c3ebfa4"
import script from "./drawer-pgd-form-causas.vue?vue&type=script&lang=js"
export * from "./drawer-pgd-form-causas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports